import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import {
  addRecentSearch,
  resetColumns,
  setVisibleColumns,
} from '@/shared/components/IndexPage/preferencesSlice';
import { setNavMode } from '@/app/navigation/navSlice';
import { savePersistedState } from './persistence';
import type { RootState } from './store';

export const listenerMiddleware = createListenerMiddleware();

// Persist only after actions that change persisted state.
listenerMiddleware.startListening({
  matcher: isAnyOf(setNavMode, setVisibleColumns, resetColumns, addRecentSearch),
  effect: (_action, api) => {
    savePersistedState(api.getState() as RootState);
  },
});
